"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Toggle_1 = require("./components/Toggle");

exports.Toggle = Toggle_1.default;

var theme_1 = require("./theme/");

exports.ReactToggleThemeProvider = theme_1.default;